<template>
    <div class="flex flex-wrap">
           <!-- <pre> {{roomList}}</pre> -->
      <vs-card class="cstm-asset-card relative" v-for="(eachList, index) in roomList" :key="index">
        <vs-dropdown
        v-if="checkEditPermission || checkDeletePermission"
        >
          <vs-button class="btn-drop" type="border" icon="more_vert"></vs-button>

          <vs-dropdown-menu>
            <vs-dropdown-item
            v-if="checkEditPermission"
            >
              <a @click="editRoom(eachList, index)">
                <!-- <feather-icon icon="EditIcon" style="width: 16px; color: green" /> -->
                Edit
              </a>
            </vs-dropdown-item>
            <vs-dropdown-item
            v-if="checkDeletePermission"
            >
              <a color="danger"
              @click="deletePopUp(eachList.assets_id,index)">
                <!-- <feather-icon icon="TrashIcon" style="width: 16px; color: red" /> -->
                Delete
              </a>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete this ?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="deleteRoom">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
    </vs-popup>
        <vs-row>
      
    
     <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
             <img
              v-if="eachList.defaultImage.length"
              class="room-img"
              :src="eachList.defaultImage[0].files_details.file_path"
            />
            <img
            v-else
              class="room-img"
              src="https://maestroselectronics.com/wp-content/uploads/2017/12/No_Image_Available.jpg"
            />
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" class="py-4">
              <div class="flex flex-wrap items-center">
                <h3 @click="roomDetails(index)" style="width: 90%;" class="cursor-pointer">
                  {{ eachList.name }}
                </h3>
                <div class="numbers py-2">
                  <span class="material-icons">person</span>
                  <span>For {{ eachList.number_of_person }} Person</span>
                </div>
              </div>
              <!-- <vs-list>
                <span class="material-icons">menu_book</span>
                <h4>Suitable For</h4>
                <vs-list-item
                  :title="eachSuitable"
                  v-for="(eachSuitable, index) in eachRoom.suitable"
                  :key="index"
                ></vs-list-item>
                <vs-list-item title="Some more text"></vs-list-item>
              </vs-list> -->
              <vs-row class="mb-6">
                <vs-col vs-type="flex" vs-align="" vs-lg="6" vs-xs="12" class="px-1">
                  <ul class="assets-list mt-2">
                    <div class="flex items-center">
                      <span class="material-icons">menu_book</span>
                      <h6 class="heading">Suitable For:</h6>
                    </div>
                    <!-- {{eachList.asset_tags}} -->
                    <li
                      :title="eachSuitable"
                      v-for="(eachSuitable, index) in eachList.asset_tags"
                      :key="index"
                    >{{eachSuitable.tag_name}}</li>
                  </ul>
                </vs-col>
                <vs-col vs-type="flex" vs-align="" vs-lg="6" vs-xs="12" class="px-1">
                  <ul class="assets-list mt-2" v-if="eachList.non_removable_inventory_list.length>0">
                    <div class="flex items-center">
                      <span class="material-icons">music_note</span>
                      <h6 class="heading">Inventory:</h6>
                    </div>
                    <li
                      :title="eachInventory"
                      v-for="(eachInventory, index) in eachList.non_removable_inventory_list"
                      :key="index"
                    >{{eachInventory.associated_assets_name}}</li>
                  </ul>
                </vs-col>
              </vs-row>
          </vs-col>
          <!-- <vs-col vs-type="flex" vs-align="" vs-w="4" class="px-4">
            <div style="display: block">
              <div class="flex items-center">
                <h3 class="mr-1">&#163;  {{ eachList.price }}</h3>
                <span>/ {{ getPriceType(eachList.price_type) }}</span>
              </div> -->
              <!-- <vs-list>
                <h4>Inventory</h4>

                <vs-list-item
                  :title="eachInventory"
                  v-for="(eachInventory, index) in eachRoom.inventory"
                  :key="index"
                ></vs-list-item>
              </vs-list> -->
            <!-- </div>
          </vs-col> -->
        </vs-row>
        <h3 class="inventory-price"><b><span v-html="currency_code"></span>{{ eachList.price }}</b><span style="font-size: 12px;">/ {{ getPriceType(eachList.price_type) }}</span></h3>
      </vs-card>
    </div>

</template>

<script>
import {deleteRoomApi} from  '@/api/room'
export default {
  data () {
    return {
      showPopUpBool: false,
      deleteId: null,
      deleteIndex: null,
      currency_code: ""
    }
  },

  mounted () {
    this.currency_code = JSON.parse(localStorage.getItem('localization')).currency.currency_symbol
  },

  props:{
    roomList:{
      type:Array,
      required:true,
      default:() => []
      
    },
    checkEditPermission:{},
    checkDeletePermission:{}
  },
  methods:{

    deletePopUp(id, deleteIndex) {
      this.showPopUpBool = true,
      this.deleteIndex = deleteIndex,
      this.deleteId = id
    },
   
    roomDetails (index) {  
      this.$router.push({
        name: 'rooms-details',
        params: {roomDetail: this.roomList[index]}
      })
    },
    editRoom (eachList) {
      
      this.$emit('editList', eachList)

    },
    
    async deleteRoom () {
      const assets_id = [this.deleteId]
      try {
        const payload = {
          customer_id : this.$store.getters.customerId,
          asset_types : 'Room',
          assets_id
        }

        const data = await deleteRoomApi(payload)
        this.showPopUpBool = false
        
        this.showSuccessMessage(
          'success',
          'Deleted Successfully',
          'success'
        )
        this.$emit('deleteRoom', this.deleteIndex)
      } catch (error) {
        
        this.showSuccessMessage(
          'success',
          'Something Went Wrong',
          'danger'
        )
      }

    },
    getPriceType (type) {
      if (type === 1) {
        return 'Per Day'
      }  else if (type === 2) {
        return 'Per Hour'
      } else {
        return 'Per Month'
      }
    }
  }
        
}
</script>

<style>
  .inventory-price {
    position: absolute;
    right: 18px;
    bottom: 20px;
  }
  .cstm-asset-card .numbers {
    min-width: 180px;
  }
</style>